<script>
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import BaseDatatable from '@components/base-datatable'
import { retinaGroupsMethods } from '@state/helpers'
import { required, minLength } from 'vuelidate/lib/validators'
import GroupsCreateForm from '@views/retina/groups/create-form'
import GroupsUpdateForm from '@views/retina/groups/update-form'

export default {
  page: {
    title: 'Groups',
    meta: [{ name: 'Groups management', content: 'Groups management' }],
  },
  components: {
    Layout,
    PageHeader,
    BaseDatatable,
    GroupsCreateForm,
    GroupsUpdateForm,
  },
  data() {
    return {
      title: 'Grupos',
      items: [
        {
          text: 'Administración',
        },
        {
          text: 'Grupos',
          active: true,
        },
      ],
      tableHeaders: [
        { key: 'name', label: 'Nombre' },
        { key: 'description', label: 'Description' },
        { key: 'warehouse', label: 'Bodega' },
        { key: 'ubications', label: 'Ubicaciones' },
        { key: 'user_set', label: 'Usuarios' },
        { key: 'permissions', label: 'Permisos' },
        { key: 'actions', label: 'Acciones' },
      ],
      action: '',
      createForm: {
        name: '',
        description: '',
      },
      updateForm: {
        name: '',
        description: '',
        warehouse: {},
        ubications: [],
        // user_set: [],
        permissions: [],
      },
      createUpdateModal: {
        id: 'create-update-modal',
        title: '',
        loading: false,
      },
      detailModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      toDelete: {},
      createUpdateModalShow: false,
      detailModalShow: false,
      deleteModalShow: false,
      isSubmitting: false,
      actionsLoadings: {},
    }
  },
  validations: {
    createForm: {
      name: {
        required,
        minLength: minLength(4),
      },
    },
    updateForm: {
      name: {
        required,
        minLength: minLength(4),
      },
    },
  },
  methods: {
    ...retinaGroupsMethods,

    myProvider(ctx) {
      const promise = this.fetchRetinaGroups(this.$table_params(ctx))
      return promise
        .then((data) => {
          return data
        })
        .catch((error) => {
          this.$axios_error_noty(error, this)
          return []
        })
    },
    openDetailModal(item, index, button) {
      let context = this
      context.isSubmitting = true
      context.actionsLoadings[button] = true
      context.detailModal.title = `Grupo: ${item.group.name}`
      const promise = context.fetchRetinaGroupsDetail(item.id)
      return promise
        .then((data) => {
          context.detailModal.content = data
          context.detailModalShow = !context.detailModalShow
          context.isSubmitting = false
          context.actionsLoadings[button] = false
        })
        .catch((error) => {
          context.$axios_error_noty(error, context)
          context.isSubmitting = false
          context.actionsLoadings[button] = false
        })
    },
    resetdetailModal() {
      this.detailModal.title = ''
      this.detailModal.content = ''
    },
    resetCreateUpdateModal(action) {
      this.createUpdateModal.title = ''
      if (action === 'create') {
        this.createForm.name = ''
        this.createForm.description = ''
        this.$v.createForm.$reset()
      } else {
        this.updateForm.name = ''
        this.updateForm.description = ''
        this.updateForm.warehouse = {}
        this.updateForm.ubications = []
        this.$v.updateForm.$reset()
      }
    },
    openCreateUpdateModal(item, index, action) {
      this.resetCreateUpdateModal(action)
      if (action === 'create') {
        this.action = 'create'
        this.createUpdateModal.title = `Nuevo Grupo`
      } else {
        this.action = 'update'
        this.updateForm.loading = true
        this.updateForm.id = item.id
        this.updateForm.name = item.group.name
        this.updateForm.description = item.group.group_info
          ? item.group.group_info.description
          : ''
        // this.updateForm.user_set = item.group.user_set
        this.updateForm.permissions = item.group.permissions_info
        this.updateForm.warehouse = Boolean(item.warehouse.id)
          ? item.warehouse
          : null
        this.updateForm.ubications = Boolean(item.ubications)
          ? item.ubications
          : null
        this.createUpdateModal.title = `Actualizar Grupo`
      }
      this.createUpdateModalShow = !this.createUpdateModalShow
    },
    onFormSubmit(evt) {
      
      evt.preventDefault()
      let context = this
      context.isSubmitting = true
      if (context.$v.createForm.$anyError) {
        context.$v.createForm.$touch()
      }
      let form =
        context.action === 'create' ? context.createForm : context.updateForm
      form.action = context.action
      if (context.action === 'update') {
        if (form.warehouse ) {
          form.warehouse = JSON.parse(JSON.stringify(form.warehouse))
          delete form.warehouse.ubications
        }
        else {
          form.warehouse = {}
        }
      }
      const promise = context.createUpdateRetinaGroups(form)
      return promise
        .then((data) => {
          if (context.action === 'update') {
            context.$generate_toast(
              context,
              'success',
              'Grupo actualizado correctamente'
            )
          } else {
            context.$generate_toast(
              context,
              'success',
              'Grupo creado correctamente'
            )
          }
          context.createUpdateModalShow = !context.createUpdateModalShow
          context.$refs.table.refresh()
          context.isSubmitting = false
        })
        .catch((error) => {
          context.$axios_error_noty(error, context)
          context.isSubmitting = false
        })
    },
    openDeleteModal(item, index) {
      let context = this
      context.toDelete = item
      context.deleteModalShow = !context.deleteModalShow
    },
    resetDeleteModal(item, index) {
      this.toDelete = {}
    },
    deleteGroup() {
      let context = this
      context.isSubmitting = true
      const promise = context.deleteRetinaGroups(context.toDelete.id)
      return promise
        .then((data) => {
          context.$generate_toast(
            context,
            'success',
            'Grupo Borrado'
          )
          context.$refs.table.refresh()
          context.isSubmitting = false
        })
        .catch((error) => {
          context.$axios_error_noty(error, context)
          context.isSubmitting = false
        })
    },
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-container fluid class="p-0">
      <b-row>
        <b-col>
          <b-card>
            <b-button
              variant="info"
              size="sm"
              @click="openCreateUpdateModal(null, null, 'create')"
            >
              <i class="fe-plus"></i>
              Nuevo
            </b-button>
            <BaseDatatable
              ref="table"
              :drfprovider="myProvider"
              :tableheaders="tableHeaders"
            >
              <template v-slot:cell(name)="row">
                {{ row.item.group ? row.item.group.name : '' }}
              </template>
              <template v-slot:cell(description)="row">
                {{
                  row.item.group.group_info
                    ? row.item.group.group_info.description
                    : ''
                }}
              </template>
              <template v-slot:cell(warehouse)="row">
                {{
                  row.item.warehouse
                    ? row.item.warehouse.description
                    : 'Sin Asignar'
                }}
              </template>
              <template v-slot:cell(ubications)="row">
                {{
                  row.item.warehouse
                    ? row.item.ubications.length
                    : 'Sin Asignar'
                }}
              </template>
              <template v-slot:cell(user_set)="row">
                {{ row.item.group.user_set.length }}
              </template>
              <template v-slot:cell(permissions)="row">
                {{ row.item.group.permissions.length }}
              </template>
              <template v-slot:cell(actions)="row">
                <b-button-group size="xs">
                  <b-button
                    :id="`info-btn-${row.index}`"
                    variant="outline-info btn-transparent"
                    size="xs"
                    :disabled="
                      isSubmitting || actionsLoadings[`info-btn-${row.index}`]
                    "
                    @click="
                      openDetailModal(
                        row.item,
                        row.index,
                        `info-btn-${row.index}`
                      )
                    "
                  >
                    <i
                      v-if="!actionsLoadings[`info-btn-${row.index}`]"
                      class="fe-info fe-2x"
                    ></i>
                    <b-spinner
                      v-if="actionsLoadings[`info-btn-${row.index}`]"
                      small
                      label="Spinning"
                      variant="info"
                    >
                    </b-spinner>
                  </b-button>
                  <!-- <b-tooltip
                    :target="`info-btn-${row.index}`"
                    triggers="hover"
                    variant="info"
                  >
                    Info
                  </b-tooltip> -->

                  <b-button
                    :id="`update-btn-${row.index}`"
                    :disabled="isSubmitting"
                    variant="outline-warning btn-transparent"
                    size="xs"
                    @click="
                      openCreateUpdateModal(row.item, row.index, 'update')
                    "
                  >
                    <i class="fe-edit fe-2x"></i>
                  </b-button>
                  <!-- <b-tooltip
                    :target="`update-btn-${row.index}`"
                    triggers="hover"
                    variant="warning"
                  >
                    Edit
                  </b-tooltip> -->

                  <b-button
                    :id="`delete-btn-${row.index}`"
                    :disabled="isSubmitting"
                    variant="outline-danger btn-transparent"
                    size="xs"
                    @click="openDeleteModal(row.item, row.index)"
                  >
                    <i class="fe-x fe-2x"></i>
                  </b-button>
                  <b-tooltip
                    :target="`delete-btn-${row.index}`"
                    triggers="hover"
                    variant="danger"
                  >
                    Borrar
                    </b-tooltip>
                </b-button-group>
              </template>
            </BaseDatatable>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
    <!-- Detail modal -->
    <b-modal
      :id="detailModal.id"
      v-model="detailModalShow"
      :title="detailModal.title"
      ok-only
      @hide="resetdetailModal"
    >
      <!-- <pre>{{ detailModal.content }}</pre> -->
      <table v-if="detailModal.content" class="table-hover table-sm mb-0">
        <tr>
          <th style="text-align:right"> Nombre </th>
          <td>{{ _.capitalize(detailModal.content.group.name) }}</td>
        </tr>
        <tr>
          <th style="text-align:right">Descripción</th>
          <td>
            {{
              detailModal.content.group.group_info
                ? detailModal.content.group.group_info.description
                : ''
            }}
          </td>
        </tr>
        <tr>
          <th style="text-align:right">Bodega</th>
          <td>
            {{
              detailModal.content.warehouse.id
                ? detailModal.content.warehouse.description
                : 'Sin Asignar'
            }}
          </td>
        </tr>
        <tr>
          <th style="text-align:right">Ubicaciones</th>
          <td v-if="detailModal.content.ubications">
            <ul>
              <li
                v-for="(ubication, index) in detailModal.content.ubications"
                :key="index"
              >
                {{ ubication.name }}
              </li>
            </ul>
          </td>
          <td v-else>Acceso total</td>
        </tr>
        <tr>
          <th style="text-align:right">Permisos</th>
          <td v-if="detailModal.content.group.permissions_info.length">
            <ul>
              <li
                v-for="(permission, index) in detailModal.content.group
                  .permissions_info"
                :key="index"
              >
                {{ permission.name }}
              </li>
            </ul>
          </td>
          <td v-else>Sin permisos asignados</td>
        </tr>
        <tr>
          <th style="text-align:right">Usuarios</th>
          <td v-if="detailModal.content.group.users_set_info.length">
            <ul>
              <li
                v-for="(user, index) in detailModal.content.group
                  .users_set_info"
                :key="index"
              >
                {{
                  user.first_name
                    ? `${user.first_name} ${user.last_name} (${user.username})`
                    : user.username
                }}
              </li>
            </ul>
          </td>
          <td v-else>Sin Usuarios</td>
        </tr>
      </table>
    </b-modal>
    <!-- Create-Update modal -->
    <b-modal
      :id="createUpdateModal.id"
      v-model="createUpdateModalShow"
      :title="createUpdateModal.title"
      :size="action === 'create' ? 'sm' : 'lg'"
    >
      <GroupsCreateForm
        v-if="action === 'create'"
        :validator="$v.createForm"
        :onformsubmit="onFormSubmit"
        :form="createForm"
      >
      </GroupsCreateForm>
      <GroupsUpdateForm
        v-if="action === 'update'"
        :validator="$v.updateForm"
        :onformsubmit="onFormSubmit"
        :form="updateForm"
      >
      </GroupsUpdateForm>
      <template v-slot:modal-footer>
        <b-button
          variant="secondary"
          size="sm"
          class="float-right"
          @click="createUpdateModalShow = !createUpdateModalShow"
        >
          Cancel
        </b-button>
        <b-button
          type="submit"
          form="form"
          size="sm"
          variant="primary"
          :disabled="
            action === 'create'
              ? $v.createForm.$invalid || isSubmitting
              : $v.updateForm.$invalid || isSubmitting
          "
        >
          <span v-if="!isSubmitting">
            {{ $t('submit') }}
          </span>
          <b-spinner v-if="isSubmitting" small label="Spinning" variant="light">
          </b-spinner>
        </b-button>
      </template>
    </b-modal>
    <!-- Delete modal -->
    <b-modal
      id="delete-modal"
      v-model="deleteModalShow"
      title="Borrar Grupo"
      ok-title="Borrar"
      ok-variant="danger"
      @hidden="resetDeleteModal"
      @ok="deleteGroup"
    >
      <p>
        ¿Esta seguro de Borrar el grupo? 
        {{ toDelete ? toDelete.name : '' }}
      </p>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button size="sm" variant="secondary" @click="cancel">
          Cancelar
        </b-button>
        <b-button
          size="sm"
          variant="danger"
          :disabled="isSubmitting"
          @click="ok"
        >
          <span v-if="!isSubmitting">
            {{ $t('delete') }}
          </span>
          <b-spinner v-if="isSubmitting" small label="Spinning" variant="light">
          </b-spinner>
        </b-button>
      </template>
    </b-modal>
  </Layout>
</template>
